// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- 模板配置（运营管理 / 模板配置） ----------
const TEMPLATES = [
  {
    id: "tpl_basic_white",
    temple_id: "temple_basic_white",
    name: "基础白模版",
    category: "基础",
    icon: "⬜",
    color: "from-white to-slate-100",
    desc: "最简单的 H5 白模版：顶部支持配置一张主图，下方固定两个点击按钮：下载游戏、回到游戏。",
    channels: 0,
    languages: 1,
    used_count: 0,
    is_official: true,
    is_default: true,
    updated: "2026-06-22",
    sample_title: "主图 + 下载游戏 / 回到游戏",
    layout: "basic_white",
  },
];

// ---------- LandingPage：运营基于 Temple 模板调用后生成的可编辑实例 ----------
const LANDING_PAGES = [
  {
    id: "lp_001_new",
    temple_id: "temple_001",
    source_type: "temple",
    content_type: "share_content",
    name: "王者征途新用户邀请 LandingPage",
    audience_rule: "被分享者为新用户 / 未安装",
    owner: "张三",
    created_at: "2026-05-12 10:12",
    updated_at: "2026-05-15 17:20",
    status: "released",
    title: "Join me in epic battle!",
  },
  {
    id: "lp_001_return",
    temple_id: "temple_001",
    source_type: "temple",
    content_type: "share_content",
    name: "王者征途回流玩家 LandingPage",
    audience_rule: "被分享者 14 天未登录 / 曾安装",
    owner: "张三",
    created_at: "2026-05-12 10:20",
    updated_at: "2026-05-15 17:25",
    status: "released",
    title: "Your guild needs you back!",
  },
  {
    id: "lp_002_tw",
    temple_id: "temple_002",
    source_type: "temple",
    content_type: "share_content",
    name: "梦幻西游台港澳本地化 LandingPage",
    audience_rule: "被分享者地区为 TW / HK / MO",
    owner: "李四",
    created_at: "2026-05-10 13:40",
    updated_at: "2026-05-14 18:08",
    status: "released",
    title: "Invite friends to Fantasy West",
  },
  {
    id: "lp_003_event_new",
    temple_id: "temple_005",
    source_type: "temple",
    content_type: "share_content",
    name: "节日活动新用户 LandingPage",
    audience_rule: "被分享者为新用户 / 活动期内",
    owner: "李四",
    created_at: "2026-05-10 14:05",
    updated_at: "2026-05-10 14:05",
    status: "draft",
    title: "Limited time event rewards!",
  },
  {
    id: "lp_003_event_pay",
    temple_id: "temple_005",
    source_type: "temple",
    content_type: "share_content",
    name: "节日活动高价值用户 LandingPage",
    audience_rule: "被分享者历史付费 / 高 LTV 预测",
    owner: "李四",
    created_at: "2026-05-10 14:10",
    updated_at: "2026-05-10 14:10",
    status: "draft",
    title: "Exclusive rewards for top players!",
  },
  {
    id: "lp_003_event_url",
    temple_id: null,
    source_type: "url",
    content_type: "url",
    name: "节日活动跳转 URL LandingPage",
    audience_rule: "分享过程中直接跳转活动落地页",
    owner: "李四",
    created_at: "2026-05-10 14:12",
    updated_at: "2026-05-10 14:12",
    status: "draft",
    url: "https://event.fantasywest.com/spring-2026",
    title: "https://event.fantasywest.com/spring-2026",
  },
  {
    id: "lp_004_guild_recruit",
    temple_id: "temple_003",
    source_type: "temple",
    content_type: "share_content",
    name: "联盟招募活动 LandingPage",
    audience_rule: "被分享者偏好公会 / 联盟玩法",
    owner: "赵六",
    created_at: "2026-06-01 09:30",
    updated_at: "2026-06-05 16:40",
    status: "released",
    title: "Join my alliance and win together!",
  },
  {
    id: "lp_005_first_pay",
    temple_id: "temple_004",
    source_type: "temple",
    content_type: "share_content",
    name: "首充福利活动 LandingPage",
    audience_rule: "被分享者为新用户 / 未付费用户",
    owner: "王五",
    created_at: "2026-05-30 11:20",
    updated_at: "2026-06-05 15:10",
    status: "released",
    title: "Claim your first top-up bonus now!",
  },
  {
    id: "lp_006_anniversary",
    temple_id: "temple_005",
    source_type: "temple",
    content_type: "share_content",
    name: "周年庆福利 LandingPage",
    audience_rule: "被分享者为全量用户 / 活动期内",
    owner: "张三",
    created_at: "2026-05-28 14:00",
    updated_at: "2026-06-04 18:25",
    status: "released",
    title: "Anniversary rewards are waiting!",
  },
  {
    id: "lp_007_discord_party",
    temple_id: "temple_001",
    source_type: "temple",
    content_type: "share_content",
    name: "Discord 组队邀请 LandingPage",
    audience_rule: "被分享者来自 Discord / 社群渠道",
    owner: "赵六",
    created_at: "2026-05-27 10:45",
    updated_at: "2026-06-03 20:10",
    status: "released",
    title: "Squad up on Discord tonight!",
  },
  {
    id: "lp_008_jp_campaign",
    temple_id: "temple_002",
    source_type: "temple",
    content_type: "share_content",
    name: "日本上线预热 LandingPage",
    audience_rule: "被分享者地区为 JP / 日语环境",
    owner: "李四",
    created_at: "2026-05-26 16:15",
    updated_at: "2026-06-02 13:50",
    status: "draft",
    title: "Japan launch pre-registration rewards!",
  },
  {
    id: "lp_009_return_reward",
    temple_id: "temple_001",
    source_type: "temple",
    content_type: "share_content",
    name: "老玩家回流礼包 LandingPage",
    audience_rule: "被分享者 30 天未登录 / 曾付费",
    owner: "张三",
    created_at: "2026-05-25 09:10",
    updated_at: "2026-06-01 17:35",
    status: "released",
    title: "Come back for exclusive rewards!",
  },
  {
    id: "lp_010_ramadan_event",
    temple_id: "temple_005",
    source_type: "temple",
    content_type: "share_content",
    name: "东南亚节日活动 LandingPage",
    audience_rule: "被分享者地区为 SG / MY / ID",
    owner: "王五",
    created_at: "2026-05-24 15:25",
    updated_at: "2026-05-31 19:20",
    status: "released",
    title: "Limited festival rewards for SEA players!",
  },
  {
    id: "lp_011_halloween",
    temple_id: "temple_005",
    source_type: "temple",
    content_type: "share_content",
    name: "万圣节限时礼包 LandingPage",
    audience_rule: "被分享者为活动期内全量用户",
    owner: "赵六",
    created_at: "2026-05-23 12:00",
    updated_at: "2026-05-30 21:05",
    status: "draft",
    title: "Spooky rewards are live!",
  },
];

export { TEMPLATES, LANDING_PAGES };
